<template>
    <SwipeModalComponent v-if="cardAdditionMenu.isVisible" @closeMenu="closeCardAdditionMenuVisibility">
        <div class="content-wrapper">
            <h2 v-text="'Adicionar Cartão'"></h2>
            <div class="menu-fields-container">
                <div class="input-cont">
                    <div class="input-container" v-for="(input, key) in cardAdditionMenu.inputs" :key="key" :class="{ half: input.half, checkbox: input.type === 'checkbox' }">
                        <label :for="getId(input.display)" v-text="input.display" :class="{ required: input.required }"></label>
                        <input :id="getId(input.display)" :placeholder="input.placeHolder" :maxlength="input.maxlength ? input.maxlength : ''" :type="input.type" v-model.trim="formattedValue[getId(input.display)]" ref="input" @input="formatValue(getId(input.display), input.format)" />
                    </div>
                </div>
            </div>

            <div class="confirmButton">
                <button @click='addCard'>Confirmar</button>
            </div>
        </div>
    </SwipeModalComponent>
</template>
<script >
import SwipeModalComponent from './SwipeModalComponent.vue'
import { mapGetters, mapActions } from 'vuex'
import { getFlagCards } from '@/components/controllers/CardsController'
import { showErrorNotification } from '@/libs/Util.js'
import moment from 'moment'

export default {
    name: 'CardAdditionComponent',
    emits: ['addCard'],
    components: {
        SwipeModalComponent
    },
    data () {
        return {
            formattedValue: {
                tornarestecartaoprincipal: false
            },
            error: false,
            messages: [],
            wait: false
        }
    },
    computed: {
        ...mapGetters(['cardAdditionMenu', 'newCardValues'])
    },
    mounted () {
        document.getElementById('cards-container').scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        this.formattedValue = {
            tornarestecartaoprincipal: false
        }
    },
    methods: {
        ...mapActions(['changeCardAdditionMenuVisibility', 'setNewCardValues', 'clearNewCardValues', 'showModalInfo']),
        closeCardAdditionMenuVisibility: function () {
            this.clearNewCardValues()
            this.formattedValue = {}
            this.changeCardAdditionMenuVisibility()
        },
        addCard: function () {
            const isValidInputs = this.validadeInputs()
            if (isValidInputs) {
                this.$emit('addCard')
            }
        },
        getId: function (display) {
            return display.replaceAll(' ', '').toLowerCase().normalize('NFD').replace(/[^a-zA-Z\s]/g, '')
        },
        formatValue: function (id, format) {
            if (format === 'cardNumber') {
                this.formattedValue[id] = this.formattedValue[id].replace(/\D/g, '')
                this.formattedValue[id] = this.formattedValue[id].replace(/(\d{4})(\d)/, '$1 $2').replace(/(\d{4})(\d)/, '$1 $2').replace(/(\d{4})(\d)/, '$1 $2')
                this.formattedValue[id] = this.fixInputLength(this.formattedValue[id], 19)
                this.getFlagCard(this.formattedValue[id])
            }

            if (format === 'cardDate') {
                this.formattedValue[id] = this.formattedValue[id].replace(/\D/g, '')
                this.formattedValue[id] = this.formattedValue[id].replace(/(\d{2})(\d)/, '$1/$2')
                this.formattedValue[id] = this.fixInputLength(this.formattedValue[id], 5)
            }
            if (format === 'cardCVV') {
                this.formattedValue[id] = this.formattedValue[id].replace(/\D/g, '')
                this.formattedValue[id] = this.fixInputLength(this.formattedValue[id], 3)
            }
            if (format === 'checkbox') {
                this.formattedValue[id] = !this.formattedValue[id]
            }
            if (typeof this.formattedValue[id] === 'string') {
                this.formattedValue[id] = this.formattedValue[id].toUpperCase()
            }
            this.setNewCardValues({ id: id, value: this.formattedValue[id] })
        },
        fixInputLength (inputValue, length) {
            if (inputValue.length > length) {
                inputValue = inputValue.slice(0, length)
            }
            return inputValue
        },
        getFlagCard: function (cardNumber) {
            this.setNewCardValues({ id: 'flag', value: getFlagCards(cardNumber) })
        },
        validadeInputs: function () {
            this.cardAdditionMenu.inputs.forEach(input => {
                if (input.required && !this.newCardValues[this.getId(input.display)]) {
                    this.error = true
                    this.messages.push(`O campo ${input.display} deve ser preenchido`)
                }
            })
            if (this.error) {
                this.showMessages()
                return false
            }

            if (!this.newCardValues.flag) {
                this.error = true
                this.messages.push('O cartão informado é inválido')
            }

            if (this.newCardValues.nomedotitular.length < 3) {
                this.error = true
                this.messages.push('Nome do Titular inválido')
            }
            const validade = moment(this.newCardValues.validade, 'MM/YY')
            const now = moment()
            if (!validade.isValid()) {
                this.error = true
                this.messages.push('Data inválida')
            }
            if (validade < now) {
                this.error = true
                this.messages.push('A data de validade do cartão expirou')
            }

            if (this.newCardValues.cvv.length < 3) {
                this.error = true
                this.messages.push('O CVV informado é inválido')
            }
            if (this.error) {
                this.showMessages()
                return false
            }
            return true
        },
        showMessages: function () {
            this.messages.reverse().forEach(e => {
                showErrorNotification({
                    title: '',
                    text: e
                })
            })
            this.messages = []
            this.error = false
        }
    }
}
</script>

<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;

    h2 {
        text-align: center;
        &:last-of-type {
            margin-bottom: 40px;
        }
    }
    .menu-fields-container {
        padding: 0 15px;
        overflow: auto;
        margin-bottom: 30px;
    }

    .confirmButton {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    button {
        text-align: right;
        border-radius: 5px;
        color: var(--buttonText);
        padding: 10px;
        margin: 0px 15px 20px 15px;
        font-weight: 600;
        border: none;
        background-color: var(--buttonBackground);
    }

    .input-cont {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .input-container {
        margin-bottom: 15px;
        font-size: 16px;

            &.half {
                width: calc(50% - 10px);
            }

            // no half
            &:not(.half) {
                display: block;
                width: calc(100%);
            }

            label {
                display: block;
                margin-bottom: 5px;

                &.required:after {
                content: '*';
                color: red;
                margin-left: 5px;
                }
            }

            input {
                width: calc(100% - 30px);
                padding: 15px;
                font-size: 16px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: 7px;
                margin-top: 10px;
            }
            &.checkbox {
                display: flex;
                flex-direction: row-reverse;
                align-items: baseline;
                justify-content: flex-end;
                input {
                    width: auto;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    border-radius: 7px;
                    accent-color: var(--buttonBackground);
                    margin: 10px 10px 0 0;
                }
            }
        }
    }
}
</style>
